import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, notification, Space } from "antd";
import { privacy } from "../../urls";
import { Link } from "react-router-dom";
import { initializePostHog, resetPostHog } from "../../helpers/posthogManager";
import { initializeAnalytics } from "../../services/firebase";

const Context = React.createContext({ name: "Default" });

const CookieBanner = () => {
  const { t } = useTranslation();
  const [api, contextHolder] = notification.useNotification();
  const [analyticsLoaded, setAnalyticsLoaded] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem("consentGranted");

    if (!cookieConsent) {
      openNotification("bottomRight");
    } else if (cookieConsent === "true" && !analyticsLoaded) {
      setGtag();
      initializeAnalytics();
      setAnalyticsLoaded(true);
    }
  }, []);

  const contextValue = useMemo(() => ({ name: "Cookies" }), []);

  const openNotification = (placement) => {
    const btn = (
      <Space>
        <Link to={privacy}>
          <Button type="link" size="small">
            {t("read_more")}
          </Button>
        </Link>
        <Button size="small" onClick={handleDecline}>
          {t("cookiebar_decline")}
        </Button>
        <Button type="primary" size="small" onClick={handleAccept}>
          {t("cookiebar_accept")}
        </Button>
      </Space>
    );
    api.open({
      message: t("cookiebar_title"),
      description: t("cookiebar_description"),
      duration: 0,
      closeIcon: null,
      placement,
      btn,
    });
  };

  const handleAccept = () => {
    localStorage.setItem("consentGranted", "true");

    // Initialize analytics systems
    setGtag();
    initializeAnalytics();

    // Initialize PostHog
    initializePostHog();

    setAnalyticsLoaded(true);
    api.destroy();
  };

  const handleDecline = () => {
    localStorage.setItem("consentGranted", "false");

    // Ensure PostHog is reset if it was previously initialized
    resetPostHog();

    api.destroy();
  };

  const setGtag = () => {
    function gtag() {
      window?.dataLayer.push(arguments);
    }

    gtag("consent", "update", {
      ad_user_data: "granted",
      ad_personalization: "granted",
      ad_storage: "granted",
      analytics_storage: "granted",
    });

    // Load gtag.js script.
    let gtagScript = document.createElement("script");
    gtagScript.async = true;
    gtagScript.src =
      "https://www.googletagmanager.com/gtag/js?id=Google tag ID";

    let firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(gtagScript, firstScript);
  };

  return (
    <Context.Provider value={contextValue}>{contextHolder}</Context.Provider>
  );
};

export default CookieBanner;
